









































import Vue from "vue";
import apexchart from "vue-apexcharts";
import MyMixin from "@/mixins/datemixin";
import MobileMixin from "@/mixins/mobileMixin";
import { Prop, Component, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";

@Component({
  components: {
    apexchart,
  },
})
export default class GraphDonut extends mixins() {
  public testDonut = true;
  public devise = "€";

  @Prop() public options!: any;
  @Prop() public series!: any;
  @Prop() public type!: any;
}
